<div class="dashboard-container">
  <!-- Show loading while searchProjects request is in-flight -->
  <ng-container *ngIf="!isLoading; else loading">
    <!-- Data section: either list projects or show empty state -->
    <ng-container *ngIf="myProjects && myProjects.length > 0; else empty">
      <div class="project" *ngFor="let project of myProjects">
        <div class="project-header" (click)="clickProjectItem(project)">
          <div class="flex align-center">
            <ng-container *ngIf="project.logo">
              <img [src]="SERVER_URL + 'images/' + project.projectCode + '/images/' + project.logo.fileName"
                   style="width: auto; height: 60px; max-width: 200px; object-fit: contain;">
            </ng-container>
            <ng-container *ngIf="!project.logo">
              <img src="./assets/images/default-project-logo.jpg"
                   style="width: auto; max-height: 60px; object-fit: contain;">
            </ng-container>
            <div style="display: flex; flex-direction: column; justify-content: center; " class="ml_15">
              <h4 style=" font-size: 14px; margin-top: 0; margin-bottom: 0" class="fc_DEDEDE">
                {{ project.name }}
              </h4>
              <p
                style=" letter-spacing: 1px; margin-bottom: 3px; margin-top: 0; font-size: 12px; color: rgba(222, 222, 222, 0.6);margin-top: 15px;">
                {{ project.addressLine2 }}
                , {{ project.area }} {{ project.state }} {{ project.postCode }}</p>
            </div>
          </div>
          <div class="flex align-center fz_14" style="color: #FFAA21;">
            <div style="width:5px;height:5px;border-radius:50%;background:#FFAA21"
                 class="{{statusesData(project.status)}}bg"></div>
            <div style="margin-left: 5px;"
                 [ngClass]="statusesData(project.status)"> {{ statusesData(project.status) }}
            </div>
          </div>
          <!-- <img src="./assets/images/black/love.png" class="love_image"> -->
        </div>

        <ng-container *ngIf="currentUserId === 'dev-admin@aus-pac.com'">
          <div fxLayout="row" fxLayoutGap="20px">
            <app-timeline [projectId]="project.id" fxFlex="45"></app-timeline>
            <app-year-trend [projectId]="project.id" fxFlex="31"></app-year-trend>
            <app-property-type [projectId]="project.id" fxFlex="12"></app-property-type>
            <app-buyer-segmentation fxFlex="12" [projectId]="project.id"></app-buyer-segmentation>
          </div>
        </ng-container>

        <div *ngIf="currentUserId !== 'dev-admin@aus-pac.com'">
          <div fxLayout="row" fxLayoutGap="20px">
            <app-property-type [projectId]="project.id" fxFlex="30"></app-property-type>
            <app-timeline [projectId]="project.id" fxFlex="35"></app-timeline>
            <app-year-trend [projectId]="project.id" fxFlex="35"></app-year-trend>
          </div>
          <div fxLayout="row" fxLayoutGap="20px">
            <app-buyer-segmentation [projectId]="project.id" fxFlex="30"></app-buyer-segmentation>
            <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="10px" fxFlex="60"
                 *ngIf="project.demography">
              <div fxLayout="row" fxLayoutGap="10px">
                <div fxFlex="33" class="region-item">
                  <div class="value"> {{
                      project.demography.population ? project.demography.population :
                        '-'
                    }}
                  </div>
                  <div class="title">total population in {{ project.area }}</div>
                </div>
                <div fxFlex="33" class="region-item">
                  <div class="value"> {{ project.demography.median_age }}</div>
                  <div class="title">median age of {{ project.area }}</div>
                </div>
                <div fxFlex="33" class="region-item">
                  <div class="value">
                    <ng-container *ngIf="project.demography.median_weekly_household_income != 0">
                      {{
                        project.demography.median_weekly_household_income | currency:
                          '':'symbol':'3.0'
                      }}
                    </ng-container>
                    <ng-container *ngIf="project.demography.median_weekly_household_income == 0">
                      -
                    </ng-container>
                  </div>
                  <div class="title">median weekly household income</div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutGap="10px">
                <div fxFlex="33" class="region-item">
                  <div class="value">
                    <ng-container *ngIf="project.owner && project.rented">
                      <ng-container *ngIf="project.owner >= project.rented">
                        {{ project.rentRatio }} : 1
                      </ng-container>
                      <ng-container *ngIf="project.owner < project.rented">
                        1 : {{ project.rentRatio }}
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="!project.owner || !project.rented">
                      -
                    </ng-container>
                  </div>
                  <div class="title">
                    <ng-container *ngIf="project.owner && project.rented">
                      <ng-container *ngIf="project.owner >= project.rented">
                        Owner : Renter
                      </ng-container>
                      <ng-container *ngIf="project.owner < project.rented">
                        Renter : Owner
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="!project.owner || !project.rented">
                      Owner : Renter
                    </ng-container>
                  </div>
                </div>
                <div fxFlex="33" class="region-item">
                  <div class="value">
                    <ng-container *ngIf="project.employed && project.unemployed">
                      <ng-container *ngIf="project.employed >= project.unemployed">
                        {{ project.employRatio }} : 1
                      </ng-container>
                      <ng-container *ngIf="project.employed < project.unemployed">
                        1 : {{ project.employRatio }}
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="!project.employed || !project.unemployed">
                      -
                    </ng-container>
                  </div>
                  <div class="title">
                    <ng-container *ngIf="project.employed && project.unemployed">
                      <ng-container *ngIf="project.employed >=project. unemployed">
                        Employed : Unemployed
                      </ng-container>
                      <ng-container *ngIf="project.employed < project.unemployed">
                        Unemployed : Employed
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="!project.employed || !project.unemployed">
                      Employed : Unemployed
                    </ng-container>
                  </div>
                </div>
                <div fxFlex="33" class="region-item">
                  <div class="value">Professionals</div>
                  <div class="title">Top Occupation Group</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </ng-container>
  </ng-container>
  <ng-template #loading>
    <app-loading></app-loading>
  </ng-template>
  <ng-template #empty>
    <!-- Simple empty state when there is no project data returned -->
    <div class="empty-state" fxLayout="column" fxLayoutAlign="center center" style="min-height: 160px;">
      <div class="fc_DEDEDE" style="opacity: 0.8;">No projects found.</div>
    </div>
  </ng-template>

</div>
<div class="paginator-footer" fxLayout="row" fxLayoutAlign="end center"
     *ngIf="!isLoading && (myProjects && myProjects.length >= 0)">
  <mat-paginator
    [length]="total"
    [pageIndex]="page"
    [pageSize]="pageSize"
    [pageSizeOptions]="[5, 10, 20, 50]"
    [showFirstLastButtons]="true"
    (page)="onPageChange($event)">
  </mat-paginator>
</div>
